import React from "react";
import styles from "./button.module.scss";

const Index = ({ label = "Submit", type = "primary", onClick = () => {}, isDisabled = true }) => {
  return (
    <div className={styles["wrapper"]}>
      <button disabled={isDisabled} onClick={onClick} className={`${styles[type]} ${isDisabled ? styles["btn-disabled"] : ""}`}>
        {label}
      </button>
    </div>
  );
};

export default Index;
